import React, { useEffect } from "react";
import { X } from "lucide-react";
import styled, { css } from "styled-components";
import "../styles/customModal.scss";
import { useAuth } from "../context/userContext";
const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease, visibility 0.4s ease;
  z-index: 5000;

  ${({ show }) =>
    show &&
    css`
      opacity: 1;
      visibility: visible;
    `}
`;

const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  box-sizing: border-box;
  @media screen and (max-width: 500px) {
    max-width: 90%;
    width: 100%;
    // max-height: 100vh;
    overflow-y: scroll;
  }
  @media screen and (max-width: 400px) {
    max-width: 100% !important;
    width: 95vw !important;
    // height: 100vh;
    border-radius: 0;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #124b04;
  transition: color 0.2s ease;
  width: 30px;
  height: 30px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  z-index: 999;
  right: 0;
  border-bottom-left-radius: 50%;
  transition: 0.4s;

  &:hover {
    background: red;
  }
`;

const CheckoutModal = ({
  show,
  setShow,
  background,
  padding,
  width,
  maxWidth,
  children,
}) => {
  const { auth } = useAuth();
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);
  return (
    <Modal show={show}>
      <ModalContent
        className="modal_scroll custom_modal"
        style={{
          background: background ? background : "",
          padding: padding ? padding : "",
          maxWidth: maxWidth ? maxWidth : auth?.user?._id ? "70%" : "",
          width: width ? width : "",
        }}
      >
        <CloseButton title="Close" onClick={() => setShow(false)}>
          <X size={20} color="#124b04" />
        </CloseButton>
        {children}
      </ModalContent>
    </Modal>
  );
};

export default CheckoutModal;
